let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("YxfNT")).then(() => parcelRequire('fuRMK'));